import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown } from "react-icons/bs";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";

const cienciaColumns = [
  { name: "Momento", selector: (row) => row.dsMomentoAnalisado, sortable: true, width: "20%" },
  { name: "Modo Ciência", selector: (row) => row.dsTpModoCiencia, center: true, width: "15%" },
  { name: "Data Ciência", selector: (row) => row.dtCiencia, center: true, width: "15%" },
  { name: "CPF", selector: (row) => row.nuCpf, center: true, width: "15%" },
  { name: "Nome", selector: (row) => row.nmContribuinte, width: "20%" },
  { name: "Status", selector: (row) => row.dsStCiencia, center: true, width: "15%" },
];

const PatDetalhesExpandido = ({ data }) => {
  const [ciencias, setCiencias] = useState([]);

  const { request: requestCiencias, data: dataCiencias, isLoading: loadingCiencias } = useApiClient();

  useEffect(() => {
    if (data.sqProcesso) {
      requestCiencias(apiRoutes.fiscalizacao.pat.listaMomentoCiencia, { SqProcesso: data.sqProcesso });
    }
  }, [data.sqProcesso, requestCiencias]);

  useEffect(() => {
    if (dataCiencias?.result) {
      setCiencias(dataCiencias.result || []);
    }
  }, [dataCiencias]);

  return (
    <div style={{ padding: "10px 20px" }}>
      <Row>
        <Col>
          <h6 className="font-weight-bold text-primary mb-2">Ciências Registradas</h6>
          <DataTable
            noHeader
            keyField="sqMomentoCiencia"
            columns={cienciaColumns}
            data={ciencias}
            progressPending={loadingCiencias}
            noDataComponent="Nenhuma ciência registrada"
            progressComponent={<TextSpinner />}
            sortable
            sortIcon={<BsArrowDown />}
            dense
          />
        </Col>
      </Row>
    </div>
  );
};

export default PatDetalhesExpandido;
